import { render, staticRenderFns } from "./verification_detail.vue?vue&type=template&id=52694480&scoped=true"
import script from "./verification_detail.vue?vue&type=script&lang=js"
export * from "./verification_detail.vue?vue&type=script&lang=js"
import style0 from "./verification_detail.vue?vue&type=style&index=0&id=52694480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52694480",
  null
  
)

export default component.exports